import React, { Component } from "react";
import TournamentUploadMatchResult from "./presenter";

class Container extends Component {
  render() {
    return <TournamentUploadMatchResult {...this.state} {...this.props} />;
  }
}

export default Container;
